export default function CFunctionDeclaration() {
  return <h2>C Function Declaration</h2>;
}
